import { Stack, Typography } from '@mui/material';

export const SourcingLoadingIndicator: React.FC<{
  title: string;
}> = ({ title }) => {
  return (
    <Stack py="60px" alignItems="center" gap="20px">
      <img
        src="/Find-Candidates-400x400.gif"
        alt="Finding Candidates"
        style={{ width: 200, height: 200, objectFit: 'contain' }}
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />
      <Typography
        variant="subTitle"
        sx={{ color: 'primary.main', fontWeight: '500', textAlign: 'center' }}
      >
        {title}
      </Typography>
    </Stack>
  );
};
